<template>
  <Teleport to="body">
    <div class="howto-backdrop" @click.self="$emit('close')">
      <div class="howto guide" role="dialog" aria-modal="true" aria-label="How we win">
        <button class="howto__close icon-button" aria-label="Close" @click="$emit('close')">×</button>
        <div class="howto__body">
          <h3>How we win</h3>
          <!-- Playtest 14, in month 10: "how do we win this game?" The four
               are on the table from month one; this is the same list with
               the words, where a phone can read it. -->
          <p class="guide__intro">Four ways, all open from the first month. The first to land ends the campaign - and the other peoples chase Legacy too.</p>
          <ul class="glossary glossary--dialog">
            <li v-for="v in list" :key="v.id">
              <strong>{{ v.name }}</strong> {{ v.text }}
              <span v-if="v.have !== null" class="zone__count zone__count--quiet victories__at">{{ v.have }} of {{ v.need }}</span>
            </li>
          </ul>
          <p class="guide__intro">A year is one sitting; nothing is lost between sittings. Expect several years.</p>
        </div>
        <div class="howto__nav">
          <span class="howto__dots" />
          <button class="primary howto__next" @click="$emit('close')">Got it</button>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script>
import { VICTORIES, VICTORY_ORDER, victoryProgress } from '@/engine/victory';

export default {
  name: 'Victories',
  props: { civ: { type: Object, default: null } },
  emits: ['close'],
  computed: {
    list() {
      const progress = this.civ ? victoryProgress(this.civ) : [];
      return VICTORY_ORDER.map((id) => {
        const p = progress.find((x) => x.id === id);
        return { id, name: VICTORIES[id].name, text: VICTORIES[id].text, have: p ? p.have : null, need: p ? p.need : null };
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.victories__at { margin-left: 6px; }
</style>
